import { AuthType, useFlags } from '@neo.tax/shared';

import { GoogleOAuth } from './GoogleOAuth';
import { IntuitOAuth } from './IntuitOAuth';
import { MicrosoftOAuth } from './MicrosoftOAuth';
import { StyledSsoButtonContainer, StyledSsoTitle } from './sso-buttons.styled';

export const SsoButtons = ({ authType }: { authType: AuthType }): React.ReactElement => {
  const flags = useFlags();

  return (
    <>
      <StyledSsoTitle as="p" fontSize="sm" fontWeight="medium">
        {authType === AuthType.SIGNUP ? 'Sign up with' : 'Sign in with'}
      </StyledSsoTitle>
      <StyledSsoButtonContainer gap={2}>
        <GoogleOAuth authType={authType} />
        <MicrosoftOAuth authType={authType} />
        {flags.enableIntuitSso ? <IntuitOAuth authType={authType} /> : null}
      </StyledSsoButtonContainer>
    </>
  );
};
